import { createFileRoute } from '@tanstack/react-router';

import { SubmissionView } from '@/pages/record-and-send/submission/submission-view';

function SubmissionRoute() {
	const { submissionId } = Route.useParams();
	return <SubmissionView submissionId={submissionId} />;
}

export const Route = createFileRoute('/_authenticated/_app/record-and-send/submissions/$submissionId')({
	component: SubmissionRoute,
});
